/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\User\UserTabs\UserTabs.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Monday February 12th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday February 12th 2024 3:25:55 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { Box, Tab, Tabs } from "@mui/material";
import ConnexionComponent from "Content/Connexion/ConnexionComponent/ConnexionComponent";
import { CustomTabPanel } from "Content/Stats/Stats";
import ViewsCar from "Content/Views/ViewsCar";
import translator from "MultiLanguage/TranslationWrapper";
import { OfferType } from "Type/offer.type";
import { UserSeenCarType } from "Type/seenCar.type";
import { Views } from "Type/viewsType";
import { SetURLParams } from "Utils/UrlParams";
import { useRef, useState } from "react";

type UserTabsProps = {
    userID: string
    offers: OfferType[],
    SeenCar: UserSeenCarType[],
    usertab: number | undefined,
    offertab: number | undefined
};

function a11yProps(index: number) {
    return {
      id: `User-tabs-${index}`,
      'aria-controls': `User-tabs-${index}`,
    };
};

export default function UserTabs(props: UserTabsProps) {
    const [value, setValue] = useState(props.usertab ?? 0);

    const filterSeenCars = (seenCars: UserSeenCarType[]) => {
        if (seenCars === undefined || seenCars.length === 0)
            return [];
        var carArray = seenCars.map((val) => {return {Car: val.Car}}).flat();
        var carsUnique = [...new Map(carArray.map(item =>
            [item.Car["id"], item])).values()];
        let mySeenCars = [...new Set([...seenCars.map((val) => {return {CarID: val.Car.id, Date: val.Date}}).flat()])];
        return carsUnique.map((car: any) => {return {...car.Car, seenCars: mySeenCars.filter((v) => v.CarID === car.Car.id).map(s => {return {Date: s.Date}})}});
    };

    const views = useRef<Views[]>(filterSeenCars(props.SeenCar));

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
        SetURLParams("usertab", newValue);
    };
    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="User-tabs-selector">
                    {/* <Tab label={`${translator.decode("dynamic.offers")} ${props.offers?.length ?? 0}`} {...a11yProps(0)} /> */}
                    {/* <Tab label={`${translator.decode("dynamic.favorite")} ${props.fav?.length ?? 0}`} {...a11yProps(1)} /> */}
                    <Tab label={`${translator.decode("dynamic.views")} ${props.SeenCar?.length ?? 0}`} {...a11yProps(2)} />
                    <Tab label={translator.decode("stats.connexions")} {...a11yProps(3)} />
                </Tabs>
            </Box>
            {/* <CustomTabPanel value={value} index={0}>
                <Offer userID={props.userID} offers={props.offers} showVehicleData={true} showSellName={true} offertab={props.offertab} />
            </CustomTabPanel> */}
            {/* <CustomTabPanel value={value} index={0}>
                <TablePaper headerList={["Date", "Car", "RegNb"]} items={props.fav.map(v => <UserFavRow {...v} />)} />
            </CustomTabPanel> */}
            <CustomTabPanel value={value} index={0} idlabel={"user-tab"} aria={"user-tab"}>
                <ViewsCar views={views.current} showCarInfo={true} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1} idlabel={"user-tab"} aria={"user-tab"}>
                <ConnexionComponent userID={props.userID} displayName={false} page={1} showTitle={false} />
            </CustomTabPanel>
        </Box>
    );
};
